import axios from '@/backend'

const state = {
  inbox: {}
}

const getters = {
  currentInbox (state) {
    return state.inbox
  }
}

const mutations = {
  setCurrentInbox (state, inbox) {
    state.inbox = inbox
  }
}

const actions = {
  loadMailbox ({dispatch, commit}, mailboxId) {
    axios.get('/mailboxes/' + mailboxId).then(function (response) {
      let mailbox = {
        totalActive: response.data.active_count,
        totalMine: response.data.current_user_count,
        totalAssigned: response.data.assigned_count,
        totalDrafts: response.data.drafts_count,
        id: response.data.id,
        name: response.data.name,
        subfolders: response.data.subfolders,
        subfoldersTotal: response.data.subfolders_count
      }
      commit('setCurrentInbox', mailbox)
    })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/current_inbox.js